"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = require("date-fns/format");
var getYear_1 = require("date-fns/getYear");
var parseISO_1 = require("date-fns/parseISO");
var _1 = require(".");
exports.parsePayload = function (row, columns) {
    return columns.reduce(function (obj, column, key) {
        obj[column.Name] = row[key] || row[column.Name];
        return obj;
    }, {});
};
exports.formatDate = function (value, formatString) {
    if (formatString === void 0) { formatString = 'M/d/yyyy'; }
    if (!value) {
        return '';
    }
    var parsedValue = parseISO_1.default(value);
    return getYear_1.default(parsedValue) > 0 ? format_1.default(parsedValue, formatString) : '';
};
exports.getColumnAlign = function (column) {
    switch (column.DataType) {
        case _1.ColumnDataType.NUMERIC:
            return 'right';
        case _1.ColumnDataType.BOOLEAN:
            return 'center';
        default:
            return 'inherit';
    }
};
var getCellValue = function (cellDataType, cell) {
    switch (cellDataType) {
        case _1.ColumnDataType.DATE:
            return exports.formatDate(cell, 'M/d/yyyy');
        case _1.ColumnDataType.DATE_TIME:
        case _1.ColumnDataType.DATE_TIME_UTC:
            return exports.formatDate(cell, 'M/d/yyyy h:mm a');
        case _1.ColumnDataType.BOOLEAN:
            return (cell === true ? 'Yes' : 'No');
        default:
            return (cell || '').toString();
    }
};
var objToArray = function (row) { return row instanceof Object
    ? Object.keys(row).map(function (key) { return row[key]; })
    : row; };
var processRow = function (row, columns, ignoreType) {
    var finalVal = objToArray(row)
        .reduce(function (prev, value, i) {
        if (!columns[i].Visible) {
            return;
        }
        var result = getCellValue(ignoreType ? _1.ColumnDataType.STRING : columns[i].DataType, value)
            .replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0) {
            result = "\"" + result + "\"";
        }
        return "" + (prev !== undefined ? prev : '') + (i > 0 && prev !== undefined ? ',' : '') + result;
    }, '');
    return finalVal + "\n";
};
exports.getCsv = function (gridResult, columns) { return gridResult.reduce(function (prev, row) { return prev + processRow(row, columns, false); }, processRow(columns.map(function (x) { return x.Label; }), columns, true)); };
exports.getHtml = function (gridResult, columns) { return "<table class=\"table table-bordered table-striped\"><thead><tr>" + columns
    .filter(function (c) { return c.Visible; })
    .reduce(function (prev, el) { return prev + "<th>" + (el.Label || el.Name) + "</th>"; }, '') + "</tr></thead><tbody>" + gridResult.reduce(function (prevRow, row) {
    return prevRow + "<tr>" + objToArray(row).reduce(function (prev, cell, index) {
        return !columns[index].Visible ? prev : prev + "<td>" + getCellValue(columns[index].DataType, cell) + "</td>";
    }, '') + "</tr>";
}, '') + "</tbody></table>"; };
//# sourceMappingURL=utils.js.map